export default __webpack_public_path__ + "static/media/pizza.03eb5c1a.png";